export default "__VITE_ASSET__1d9ed22f__"